/**
 * Showcase items shown at /showcase.
 *
 * To add new work just append an object to this array.
 * Supported `type` values: "image" | "video" | "link"
 *
 *   {
 *     id: "unique-id",
 *     client: "Client Name",
 *     title: "Short title",
 *     type: "image" | "video" | "link",
 *     src: "https://...jpg"           // for image
 *     src: "https://...mp4"           // for self-hosted video
 *     youtubeId: "abc123"             // OR for YouTube
 *     vimeoId: "12345678"             // OR for Vimeo
 *     url: "https://instagram.com/p/" // for link
 *     thumbnail: "https://...jpg",    // optional preview for link/video
 *     tags: ["Reel", "Editorial"],    // optional
 *     description: "Optional context",
 *   }
 */
export const showcaseItems = [
  // ---------- Jordan Young — Personal Brand / Studio ----------
  {
    id: "ashleigh-discipline-problem",
    client: "Ashleigh — Lip Blush LDN",
    title: "Discipline problem",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/msvpfhd5_discipline%20problem.mp4",
    tags: ["Personal Brand", "Reel"],
    description: "Talking-head cut on the real reason most founders stall.",
  },
  {
    id: "jordan-studio-day-0",
    client: "Jordan Young",
    title: "Day 0 — building the studio",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/gpdesm18_day%200%20of%20building%20the%20studio.mp4",
    tags: ["Series", "Studio"],
    description: "Opening episode of the build-in-public studio series.",
  },
  {
    id: "jordan-studio-day-7",
    client: "Jordan Young",
    title: "Day 7 — studio series",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/56hm5zmi_day%207.mp4",
    tags: ["Series", "Studio"],
    description: "Week one wrap from the build-in-public studio series.",
  },

  // ---------- Moi Moi Sauce — Video ----------
  {
    id: "moimoi-fridge-ad",
    client: "Moi Moi Sauce",
    title: "Fridge ad spot",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/a7n709g2_moimoi%20fridge%20ad%201.mp4",
    tags: ["Ad", "Product"],
    description: "Short-form ad spot built for paid placement and organic social.",
  },
  {
    id: "moimoi-selfridges",
    client: "Moi Moi Sauce",
    title: "Selfridges feature, part 2",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/2inxgmzv_arron%20section%20to%20selfirdges%20part%202.mp4",
    tags: ["Retail", "Reel"],
    description: "Behind the scenes of the Selfridges listing rollout.",
  },
  {
    id: "moimoi-hot-sauce-society",
    client: "Moi Moi Sauce",
    title: "Hot Sauce Society reel",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/j3gr4k1k_hot%20sauce%20society%20reel.mp4",
    tags: ["Event", "Reel"],
    description: "Event coverage cut for Instagram and TikTok feeds.",
  },
  {
    id: "moimoi-3-sauces",
    client: "Moi Moi Sauce",
    title: "Three sauces, three pairings",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/veo30cmu_3%20sauces%20and%20recommendations.mp4",
    tags: ["Product", "Education"],
    description: "Product-led reel pairing each sauce with a recommended use.",
  },
  {
    id: "moimoi-brand-reel",
    client: "Moi Moi Sauce",
    title: "Brand reel",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/lv583lsl_hf_20260514_190040_31a23442-7d19-4f6a-94f3-c647ae9e2eaa.mp4",
    tags: ["Brand", "Reel"],
    description: "Atmospheric brand cut anchoring the visual identity.",
  },

  // ---------- Editorial / Travel ----------
  {
    id: "antigua-editorial",
    client: "Studio",
    title: "Antigua editorial",
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/bb2n7fas_0430%284%29.png",
    tags: ["Editorial", "Travel"],
    description: "Editorial photography from a Studio shoot in Antigua.",
  },
  {
    id: "antigua-editorial-2",
    client: "Studio",
    title: "Antigua editorial · ii",
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/q7dsp6sw_0430%282%29.png",
    tags: ["Editorial", "Travel"],
    description: "Editorial photography from a Studio shoot in Antigua.",
  },

  // ---------- UkFilmWork & London Lighting — Image ----------
  {
    id: "uk-filmwork-ig-grid",
    client: "UkFilmWork",
    title: "Instagram grid expansion",
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/5xuo45r5_IMG_7881.jpeg",
    tags: ["Instagram", "Community"],
    description: "Daily posting cadence and reel formats that took the community from 38K to 53K.",
  },
  {
    id: "uk-filmwork-profile",
    client: "UkFilmWork",
    title: "Profile positioning",
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/yyv7rd5b_IMG_7879.PNG",
    tags: ["Positioning", "Bio"],
    description: "Profile rebuild and bio rewrite to clarify the network's monetisation path.",
  },
  {
    id: "london-lighting-ig",
    client: "London Lighting",
    title: "Editorial brand reels",
    type: "image",
    src: "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/it3um80z_IMG_7882.PNG",
    tags: ["Reels", "Story"],
    description: "Brand-story reel format that doubled IG followers from 6K to 11.7K.",
  },
];

export const showcaseFilters = ["All", "Image", "Video", "Link"];
